var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"chat",attrs:{"id":"chat","title":_vm.$t(("" + (this.chat.label)), _vm.$i18n.locale)},on:{"click":function($event){return _vm.showChat()}}},[_c('Icon',{attrs:{"icon":"chat_icon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }